package app.settings

val backendPath = "http://174.138.6.8:4123/api"
//val backendPath = "http://localhost:8080"